'use strict';

exports = module.exports = require('./src/options');
exports.version = '2.7.0';
